<template>
    <div>
        <div>
            <top-menu 
                :backVisible="false"
                :homeVisible="false"
                :aboutVisible="true"
            >
            </top-menu>
        </div>
        <div>
            <v-container fluid class="ma-0 pa-0 mt-6">
                <v-row dense>
                <v-col class="ma-0 pa-0 text-center">
                    <label class="font-weight-black blue--text text--darken-4 title">Select a Wing Below</label>
                    <div class="mt-10">
                    <v-btn color="blue darken-4" dark width="175" @click="setWingandGoHome('CAWG')">CA</v-btn><br><br>
                    <v-btn color="blue darken-4" dark width="175" @click="setWingandGoHome('HIWG')">HI</v-btn><br><br>
                    <v-btn color="blue darken-4" dark width="175" @click="setWingandGoHome('NVWG')">NV</v-btn><br><br>
                    <v-btn color="blue darken-4" dark width="175" @click="setWingandGoHome('ORWG')">OR</v-btn>
                    </div>

                </v-col>
                </v-row>
            </v-container>
        </div>
    </div>
</template>

<script>

  export default {
  components: { },
    name: 'WingSelector',
    data () {
      return {
        search: '',
      }
    },
    mounted() {
    },
    methods: {
        setWingandGoHome(wing) {
            console.log(wing)
            this.setSelWing(wing)
            this.$router.push('home')
        }
    }
  }
</script>

<style scoped>

</style>
